(function () {
  function initHomeBestSellers(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-hbs-section]:not([data-hbs-initialized])');

    sections.forEach(function (section) {
      section.setAttribute('data-hbs-initialized', 'true');

      section.addEventListener('click', function (e) {
        var cartBtn = e.target.closest('.hbs-btn-cart');
        if (cartBtn && section.contains(cartBtn)) {
          var variantId = cartBtn.getAttribute('data-variant-id');
          if (!variantId) return;

          cartBtn.classList.add('hbs-btn--loading');
          cartBtn.disabled = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('cart_add_failed');
              return res.json();
            })
            .then(function () {
              if (window.HPBMiniCart) window.HPBMiniCart.refresh({ open: true });
            })
            .catch(function (err) {
              console.error('Add to cart error:', err);
            })
            .finally(function () {
              cartBtn.classList.remove('hbs-btn--loading');
              cartBtn.disabled = false;
            });

          return;
        }

        var buyBtn = e.target.closest('.hbs-btn-buynow');
        if (buyBtn && section.contains(buyBtn)) {
          buyBtn.classList.add('hbs-btn--loading');
        }
      });
    });
  }

  window.HPBHomeBestSellers = window.HPBHomeBestSellers || {};
  window.HPBHomeBestSellers.init = initHomeBestSellers;

  initHomeBestSellers(document);

  document.addEventListener('shopify:section:load', function (event) {
    initHomeBestSellers(event.target);
  });
})();
